import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { filter, map, switchMap, takeUntil, tap } from 'rxjs/operators';
import { EmotesService } from '../../firebase/emotes.service';
import { FireSubService } from '../../firebase/fireSub.service';
import { AppState } from '../app.state';
import * as AuthActions from '../auth/auth.actions';
import { GameSocketStoreDispatcher } from '../gameSocket/gameSocket.dispatcher';
import * as EmotesActions from '../emotes/emotes.actions';

@Injectable()
export class EmotesEffects {

    private emoteCountSub: Subscription;

    constructor(
        private actions$: Actions,
        private emotesService: EmotesService,
        private gameSocketDispatcher: GameSocketStoreDispatcher,
        private store: Store<AppState>,
        private fireSubService: FireSubService,
    ) {

    }


    emotesAdded$ = createEffect(() => this.actions$.pipe(
        ofType(EmotesActions.loadEmotesAction),
        switchMap(async () => {
            return this.emotesService
                .getEmotesList()
                .then((emotesData) => {
                    return EmotesActions.emotesLoadedAction({emojis: emotesData});
                })
                .catch((error) => {
                    return EmotesActions.emotesLoadedAction({emojis: []});
                });
        }),
    ));


    emotesCountDeduct$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(EmotesActions.deductEmotesCountInFireBase),
        tap(async (action) => {
            const socket = await this.gameSocketDispatcher.getGameSocketAsPromise(action.data.gameStateId);
            return socket.deductUserEmotesCount(action.data.clientId)
                .catch((error) => {
                    console.error(error);
                });
        }),
    ), { dispatch: false });


    loginEmoteCount$ = createEffect(() => this.actions$.pipe(
        ofType(AuthActions.authenticatedAction),
        tap((action) => {
            if (this.emoteCountSub && !this.emoteCountSub.closed) return;
            this.emoteCountSub = this.emotesService.getUserEmoteCount(action.userData.uid)
                .pipe(
                    filter((data) => data != null),
                    takeUntil(this.fireSubService.unsubscriber),
                )
                .subscribe((snapshot) => {
                    if (snapshot != null && snapshot.emoji_count != null) {
                        this.store.dispatch(EmotesActions.emotesCountUpdateAction({count: snapshot.emoji_count}));
                    }
                });
        }),
    ), { dispatch: false });


    logoutEmoteCount$ = createEffect(() => this.actions$.pipe(
        ofType(AuthActions.logoutAction),
        tap(() => {
            if (this.emoteCountSub) this.emoteCountSub.unsubscribe();
        }),
        map(() => EmotesActions.emotesCountResetAction()),
    ));

}
